import createModel from 'utils/model'
import {list, create, update, remove} from 'crm/services/wechat-program'

export default createModel({
    namespace: 'crm_wxPrograms',
    state: {
        wxPrograms: [],
    },
    effects: {
        *list({payload}, {call, put}) {
            const {data} = yield call(list, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    wxPrograms: data,
                },
            })
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
    },
    reducers: {},
})
